export default __webpack_public_path__ + "static/media/outside-right-reverse.e6dfc825.mp4";